import { logReportDownload } from '../../util/auditLogger';
import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "../../components";
import { Header } from "../../components/modules";

import { FiFileText } from "react-icons/fi";
import Context from "../../Context";

import { MdPersonSearch } from "react-icons/md";
import { Spinner } from "reactstrap";
import { thaiDate } from "../../util";
import * as xlsx from "xlsx";

export const ReportAllUser = () => {
  const { callApi } = Context();
  const [allUsers, setAllUsers] = useState([]);
  const [displayedUsers, setDisplayedUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fetchProgress, setFetchProgress] = useState(0);
  const [building, setBuilding] = useState(false);

  const getUsers = async () => {
    setDisplayedUsers([]);
    setAllUsers([]);
    setFetchProgress(0);
    setLoading(true);

    const allUserData = [];
    let keepGoing = true;
    let startAtId = "";
    const limit = 1000;

    while (keepGoing) {
      const data = await callApi(
        "users-getAll",
        {
          queries: [],
          limit,
          startAfter: startAtId,
          orderBy: ["createdAt", "asc"],
        },
        { notShowLoading: true },
      );

      if (!data || !data.length || data.length < limit) {
        keepGoing = false;
      } else {
        startAtId = data[data.length - 1].id;
      }

      if (data && data.length) {
        allUserData.push(...data);
        setFetchProgress(allUserData.length);
      }
    }

    setLoading(false);
    setAllUsers(allUserData);
    setDisplayedUsers(allUserData.slice(0, 100));
  };

  const handleDownload = () => {
    if (!allUsers.length) return;
    setBuilding(true);

    // Defer to next tick so the UI can update the building state first
    setTimeout(() => {
      const headers = [
        "ลำดับ",
        "รหัสผู้ใช้",
        // "เลขสมาชิก",
        "ชื่อ",
        "นามสกุล",
        "เบอร์โทรศัพท์",
        "อีเมล",
        "วันที่สมัคร",
        "สถานะยืนยันตัวตน",
        "ธนาคาร",
        "ชื่อบัญชี",
        "เลขบัญชี",
        "สัญชาติ",
        "วันเกิด",
        "แต้มสะสม",
        "แต้มแนะนำ",
        "Line ID",
        // "UTM Source",
        // "UTM Medium",
        // "UTM Campaign",
        "ที่อยู่",
        "จังหวัด",
        "รหัสไปรษณีย์",
      ];

      const rows = allUsers.map((user, index) => [
        index + 1,
        user.id || "",
        // user.userNo || "",
        user.createdAt
          ? new Date(user.createdAt).toLocaleDateString("th-TH", {
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
            })
          : "",
        user.firstName || "",
        user.lastName || "",
        user.phone || "",
        user.email || "",
        user.verifiedId || "",
        user.bank?.bankName || user.bankName || "",
        user.bank?.accName || user.accName || "",
        user.bank?.accNo || user.accNo || "",
        user.nationality || "",
        user.dob || "",
        user.buyPoint ?? "",
        user.referPoint ?? "",
        user.lineId || "",
        // user.utm?.source || "",
        // user.utm?.medium || "",
        // user.utm?.campaign || "",
        user.address?.addr || "",
        user.address?.province || "",
        user.address?.zipcode || "",
      ]);

      const data = [
        [`รายงานผู้ใช้งานทั้งหมด ออก ณ วันที่ ${thaiDate()}`],
        [`จำนวนผู้ใช้ทั้งหมด: ${allUsers.length} คน`],
        [],
        headers,
        ...rows,
      ];

      const ws = xlsx.utils.aoa_to_sheet(data);
      const wb = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(wb, ws, "Users");
      logReportDownload();
      xlsx.writeFile(wb, `รายงานผู้ใช้ทั้งหมด_ออก_ณ_วันที่_${thaiDate()}.xlsx`);
      setBuilding(false);
    }, 50);
  };

  const handleLoadMore = () => {
    if (displayedUsers.length < allUsers.length) {
      const newLimit = Math.min(displayedUsers.length + 100, allUsers.length);
      setDisplayedUsers(allUsers.slice(0, newLimit));
    }
  };

  return (
    <div className="h-fit w-full max-w-[1600px] mb-24">
      <Header
        header="Report"
        subHeader="รายงานผู้ใช้งานทั้งหมด"
        icon={<FiFileText className="text-blue" />}
      />

      <div className="relative w-96 bg-white rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
        <div className="p-3 border-b border-gray-300">
          <p className="font-semibold">ดึงข้อมูลผู้ใช้ทั้งหมด</p>
        </div>
        <div className="relative flex flex-col gap-3 p-3">
          {loading && (
            <div className="z-50 bg-[rgb(255,255,255,0.7)] absolute h-full w-full flex justify-center items-center">
              <Spinner className="w-4 h-4" />
            </div>
          )}
          <div className="flex gap-2 items-center justify-between">
            <button
              disabled={loading || building}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-blue text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:opacity-60"
              onClick={getUsers}
            >
              <MdPersonSearch className="text-white" />
              ดึงข้อมูล
            </button>
            <button
              disabled={!allUsers.length || loading || building}
              className="flex items-center justify-center gap-1 py-2 px-3 bg-[rgb(59,176,101)] text-white text-sm font-semibold rounded-lg shadow-md hover:opacity-60 transition-all duration-200 disabled:bg-slate-300 disabled:hover:opacity-100 disabled:cursor-not-allowed"
              onClick={handleDownload}
            >
              {building ? <Spinner className="w-4 h-4" /> : null}
              {building ? "กำลังสร้างไฟล์..." : "ดาวน์โหลด XLSX"}
            </button>
          </div>

          {loading && fetchProgress > 0 && (
            <p className="text-xs text-gray-500 text-center">
              กำลังโหลด... {fetchProgress.toLocaleString()} รายการ
            </p>
          )}
        </div>
      </div>

      {/* Summary */}
      {allUsers.length > 0 && (
        <div className="grid grid-cols-3 gap-4 mt-4">
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-blue-500">
            <p className="text-sm font-medium text-gray-600">ผู้ใช้ทั้งหมด</p>
            <p className="text-2xl font-bold text-blue-600 mt-2">
              {allUsers.length.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500 mt-1">คน</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-green-500">
            <p className="text-sm font-medium text-gray-600">ยืนยันตัวตนแล้ว</p>
            <p className="text-2xl font-bold text-green-600 mt-2">
              {allUsers
                .filter((u) => u.verifiedId === "verified")
                .length.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500 mt-1">คน</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-4 border-l-4 border-yellow-500">
            <p className="text-sm font-medium text-gray-600">รอยืนยันตัวตน</p>
            <p className="text-2xl font-bold text-yellow-600 mt-2">
              {allUsers
                .filter((u) => u.verifiedId === "pending")
                .length.toLocaleString()}
            </p>
            <p className="text-xs text-gray-500 mt-1">คน</p>
          </div>
        </div>
      )}

      {/* Table */}
      {displayedUsers.length > 0 && (
        <div className="relative bg-white w-full rounded-lg shadow-md mt-4 border border-gray-300 overflow-hidden">
          <div className="flex bg-white gap-3 items-center p-3 border-b border-gray-300">
            <p className="font-semibold">ผู้ใช้งานทั้งหมด</p>
            <p className="text-xs font-semibold text-[#969797]">
              {displayedUsers.length.toLocaleString()} /{" "}
              {allUsers.length.toLocaleString()} คน
            </p>
          </div>
          <div
            className="overflow-y-auto"
            style={{ height: "600px" }}
            onScroll={(e) => {
              const { scrollTop, scrollHeight, clientHeight } = e.target;
              if (scrollHeight - scrollTop <= clientHeight + 100) {
                handleLoadMore();
              }
            }}
          >
            <Table className="w-full">
              <TableHeader className="bg-[#f2f3f5] sticky top-0 z-10">
                <TableRow>
                  <TableHead>ลำดับ</TableHead>
                  <TableHead>รหัสผู้ใช้</TableHead>
                  {/* <TableHead>เลขสมาชิก</TableHead> */}
                  <TableHead>ชื่อ-นามสกุล</TableHead>
                  <TableHead>เบอร์โทรศัพท์</TableHead>
                  <TableHead>อีเมล</TableHead>
                  <TableHead>วันที่สมัคร</TableHead>
                  <TableHead>ยืนยันตัวตน</TableHead>
                  <TableHead>ธนาคาร</TableHead>
                  <TableHead>เลขบัญชี</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {displayedUsers.map((user, index) => (
                  <TableRow key={user.id}>
                    <TableCell className="font-mono tabular-nums text-center">
                      {index + 1}
                    </TableCell>
                    <TableCell className="font-mono text-xs">
                      {user.id}
                    </TableCell>
                    {/* <TableCell className="font-mono tabular-nums text-center">
                      {user.userNo || "-"}
                    </TableCell> */}
                    <TableCell className="font-medium">
                      {user.firstName} {user.lastName}
                    </TableCell>
                    <TableCell>{user.phone || "-"}</TableCell>
                    <TableCell className="text-xs">
                      {user.email || "-"}
                    </TableCell>
                    <TableCell className="text-xs">
                      {user.createdAt
                        ? new Date(user.createdAt).toLocaleDateString("th-TH", {
                            year: "numeric",
                            month: "numeric",
                            day: "numeric",
                          })
                        : "-"}
                    </TableCell>
                    <TableCell>
                      <span
                        className={
                          user.verifiedId === "verified"
                            ? "text-green-600 font-semibold"
                            : user.verifiedId === "pending"
                              ? "text-yellow-600 font-semibold"
                              : "text-gray-400"
                        }
                      >
                        {user.verifiedId || "-"}
                      </span>
                    </TableCell>
                    <TableCell>{user.address.addr || "-"}</TableCell>
                    <TableCell>{user.address?.province || "-"}</TableCell>
                    <TableCell>{user.address?.zipcode || "-"}</TableCell>
                    <TableCell>
                      {user.bank?.bankName || user.bankName || "-"}
                    </TableCell>
                    <TableCell className="font-mono text-xs">
                      {user.bank?.accNo || user.accNo || "-"}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          {displayedUsers.length < allUsers.length && (
            <div className="p-3 text-center text-sm text-gray-500">
              Scroll to load more... ({displayedUsers.length.toLocaleString()} /{" "}
              {allUsers.length.toLocaleString()})
            </div>
          )}
        </div>
      )}
    </div>
  );
};
